import { formatPrice } from '../utils/formatPrice'
import { useUserCurrency } from './useUserCurrency'

export function useUserPrice() {
  const currency = useUserCurrency()

  /**
   * Returns a function that formats a price in the user's currency.
   *
   * @param price - The price to format.
   * @return The formatted price, or null if the currency is not available.
   */
  return (price: number) =>
    currency.value?.code && currency.value?.exchange
      ? formatPrice(price * currency.value.exchange, currency.value.code)
      : null
}
